<template>
  <q-card :flat="$q.screen.lt.md">
    <q-card-section class="text-center q-pa-xs" v-if="items && items.length>0">
      <q-avatar size="lg" dir="ltr" color="indigo" text-color="white">
        <span class="text-subtitle2"> {{ Math.round(items[items.length - 1].SaleRate) }}</span>
      </q-avatar>
      <q-icon
          v-if="items.length>1"
          :name="items[items.length - 1].SaleRate > items[items.length - 2].SaleRate?'arrow_upward':'south'"
          :color="items[items.length - 1].SaleRate > items[items.length - 2].SaleRate?'green':'red'" size="lg">
        <q-tooltip>
          نسبت به ماه گذشته
        </q-tooltip>
      </q-icon>
      <q-space/>
      <q-chip clickable color="brown" text-color="white" square label="نرخ رشد"/>
    </q-card-section>
    <q-tooltip content-class="bg-transparent text-black">
      <q-card flat bordered>
        <q-card-section>
          <LineChart :items="items" :data="this.items.map(item => item.SaleRate)" title="مقایسه نرخ رشد فروش ماهیانه"/>
        </q-card-section>
      </q-card>
    </q-tooltip>
  </q-card>
</template>

<script>
import LineChart from "@/components/OrderTrace/LineChart";

export default {
  name: "CurrentSaleRate",
  components: {LineChart},
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      orderChartOptions: {
        chart: {
          id: 'currentSaleRate',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'مقایسه نرخ رشد ماهیانه  در سال جاری',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
      },
      orderChartSeries: [{
        name: 'مقدار',
        data: []
      }],
    }
  },
  created() {
    this.orderChartSeries = [{
      data: this.items.map(item => item.SaleRate)
    }]
  }
}
</script>

<style scoped>

</style>